/**
 * @file reply-operation
 * @description 回复相关操作权限
 */

export default {
    // 是否存在置顶板块
    hasStickyReply(state) {
        return state.topicData.ext
            && state.topicData.ext.replyTopInfo
            && state.topicData.ext.replyTopInfo.replyList
            && Object.keys(state.topicData.ext.replyTopInfo.replyList).length;
    },
    // 是否已有推荐回复
    hasRecommendedReply(state) {
        return state.topicData.ext
            && state.topicData.ext.replyTopInfo
            && state.topicData.ext.replyTopInfo.replyIds
            && state.topicData.ext.replyTopInfo.replyIds.recommend;
    },
    // 是否已有采纳回复
    hasAcceptedReply(state) {
        return state.topicData.ext
            && state.topicData.ext.replyTopInfo
            && state.topicData.ext.replyTopInfo.replyIds
            && state.topicData.ext.replyTopInfo.replyIds.accept;
    },
    // 采纳推荐是否同一条
    isSameReply(state, getters) {
        return getters.hasStickyReply
            && getters.hasRecommendedReply
            && (state.topicData.ext.replyTopInfo.replyIds.accept
                === state.topicData.ext.replyTopInfo.replyIds.recommend);
    },
    // 允许对回复进行官方推荐
    canRecommend(state, getters) {
        return !getters.hasRecommendedReply
            && getters.hasOfficialPermission;
    },
    // 允许对回复进行采纳
    canAccept(state, getters) {
        return !getters.hasAcceptedReply
            && getters.canEditTopic;
    }
};
